/**
 * Create File for all data images passed. The function returns a Promise that will resolve when all
 * images are processed.
 * @param images
 * @return {Promise<any[]>}
 */
export function getFilesFromDataImages(images) {
  let imagesLoaded = [];
  let imageLoaderPromises = images.map((image) => {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.onloadend = () => {
        imagesLoaded.push({
          id: 0,
          file: {
            original: image,
            img: reader.result,
          },
          url: null,
        });
        resolve();
      };
      reader.readAsDataURL(image);
    });
  });

  return new Promise((resolve) => {
    Promise.all(imageLoaderPromises).then(() => {
      resolve(imagesLoaded);
    });
  });
}



// WEBPACK FOOTER //
// ./src/services/utils/images-util.js